<template>
<v-form v-model='isValid'>
<v-card>
  <v-card-title class='subheading' >
    <v-btn @click='get' :loading='request.loading' icon small >
      <v-icon>replay</v-icon>
    </v-btn>
    Configure Yoco
    <span class='ml-1' v-if='space && space.title' >for {{space.title}}</span>

    <v-chip v-if='isInstalled' success outline class='ml-3' >
      <v-avatar left ><v-icon color='green'>check_circle</v-icon></v-avatar>
      Connected
    </v-chip>
    <v-spacer></v-spacer>
    <v-btn :href='LINKS.REFERRAL' color='success' target='_blank' small >
      Open a Yoco account
      <v-icon small class='pl-2' >open_in_new</v-icon>
    </v-btn>
  </v-card-title>

  <request-status
    :request='request'
    :message200='successMessage'
    message204='Successfully uninstalled'
    message404='Currently not installed'
    message201='Integration installed successfully'
    @ok="$emit('ok', request)"
    @200="$emit('saved', request)"
    @201="$emit('created', request)"
    @204="$emit('deleted', request)" >
  </request-status>
  <v-card-text>
    <v-alert type='info' outline outlined :value='true' >
        You can find your Yoco payment link at:
          <a :href="LINKS.REFERRAL" >yoco.co.za</a> ->
          sell online ->
          <a :href="LINKS.PAYMENT_LINK" >payment page</a>
        <br/>Copy the online link and paste it here
      </v-alert>
      <v-flex>
        <v-text-field required
          @keydown.enter.stop='save'
          :rules="[v => !!v || 'Link is required']"
          v-model='link' prefix='https://pay.yoco/' >
        </v-text-field>
   <!-- {{request.result.settings.payment_appointments_visible}} || {{request.loading}} / {{request.data}} -->
      <template v-if='request.data && request.result && request.result.settings' >
        <v-subheader class='overline pl-0' >Options</v-subheader>
        <v-checkbox
          v-model='request.data.payment_invoices_visible'
          :disabled='request.loading'
          class='pa-0'
          label='Show on invoices' :persistent-hint='true'
          hint='Will display a button on your invoices which lets your clients pay with Yoco' ></v-checkbox>

        <v-checkbox
          v-model='request.data.payment_appointments_visible'
          :disabled='request.loading'
          class='pa-0' label='Include link on Appointment pages' ></v-checkbox>
        <v-checkbox
          v-model='request.data.payment_appointments_prepayments'
          :disabled='!(request.data.payment_appointments_visible) || request.loading'
          class='ml-4 pa-0'
          label='Allow pre-payments' :persistent-hint=true
          hint='Allow people to pay for appointments before the appointment start time' >
        </v-checkbox>
        <v-checkbox
          v-model='request.data.payment_appointments_only_if_invoiceable'
          :disabled='!(request.data.payment_appointments_visible) || request.loading'
          class='ml-4 pa-0'
          label='Only allow payments on appointments marked as "invoiceable"' :persistent-hint='true'
          hint='Payment options will not show on the appointment page unless you have explicitly marked the appointment as invoiceable' >
        </v-checkbox>
      </template>
      </v-flex>
    <!-- <v-flex>
      <v-text-field readonly v-model='secret' label='secret' hint='This is used to make sure that ' >
      </v-text-field>
    </v-flex> -->
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions >
    <v-btn v-if='isInstalled' @click='uninstalldialog=true' color='error' >Uninstall</v-btn>
    <v-spacer></v-spacer>
    <v-btn color='primary' :disabled='!isValid' :loading='request.loading' @click='save' >Save</v-btn>
  </v-card-actions>
  <v-dialog width='390px' v-model="uninstalldialog" >
    <v-card flat>
      <v-card-title class='overline' >
        Are you sure you want to uninstall Yoco?
        <v-spacer></v-spacer>
        <v-btn @click='uninstalldialog=false' icon ><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-actions >
        <v-btn @click='uninstalldialog=false' flat text >cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading='request.loading' @click='uninstall' color='error' >Uninstall</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</v-form>
</template>
<script>
import RequestStatus from '@/components/ui/RequestStatus'
import Vue from 'vue'
import {mapGetters} from 'vuex'

const LINKS = {
  REFERRAL: 'https://referral.yoco.com/32Tzfb',
  PAYMENT_LINK: 'https://portal.yoco.co.za/online/settings'
}

export default {
  name: 'YocoIntegration',
  components: { RequestStatus },
  props: {
    spaceId: { required: false }
  },
  data () {
    return {
      LINKS: LINKS,
      isValid: false,
      link: '',
      secret: '',
      uninstalldialog: false,
      invoices: true,
      appointments: true,
      prepayments: false,
      only_invoiceable: true,
      yocoBase: 'https://pay.yoco.com/',
      successMessage: 'Configuration loaded',
      request: {
        resource: 'ag.integrations',
        extra: 'yoco/configure',
        data: {
          payment_invoices_visible: true,
          payment_appointments_visible: false,
          payment_appointments_prepayments: false,
          payment_appointments_only_if_invoiceable: false
        }
      }
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          this.request.params = {space: this.spaceId}
        } else {
          this.request.params = {}
        }
        this.get()
      }
    },
    link () {
      if (this.link.startsWith(this.yocoBase)) {
        this.link = this.link.replace(this.yocoBase, '')
      }
    },
    appointments () {
      if (this.appointments === false) {
        this.prepayments = false
        this.only_invoiceable = false
      }
    },
    config () {
      if (this.config && this.config.link) {
        this.link = this.config.link
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        if (this.config) {
          this.request.data = this.config
        }
      }
      if (this.requestStatus === 204) {
        this.request.data = {}
        this.link = ''
        let vm = this
        window.setTimeout(() => { vm.uninstalldialog = false }, 1000)
      }
      if (this.requestStatus === 404) {
        this.link = ''
      }
    },
    showOnAppointments () {
      if (this.showOnAppointments === false) {
        Vue.set(this.request.data, 'payment_appointments_only_if_invoiceable', false)
        Vue.set(this.request.data, 'payment_appointments_prepayments', false)
      }
    }
  },
  methods: {
    get () {
      this.successMessage = 'Configuration successully loaded'
      this.$request('get', this.request)
    },
    save () {
      this.successMessage = 'Configuration saved'
      this.request.data['link'] = this.yocoBase + this.link
      if (this.spaceId) {
        this.request.data['space'] = this.spaceId
      }
      this.$request('save', this.request)
    },
    uninstall () {
      this.request.data = {}
      this.$request('delete', this.request)
    }
  },
  computed: {
    ...mapGetters(['getSpaceById']),
    space () {
      if (this.spaceId) { return this.getSpaceById(this.spaceId) }
      return null
    },
    config () {
      return this.getObjectPath(this.request, 'result.settings', {})
    },
    isInstalled () {
      if (this.config && this.config.link) {
        return true
      }
      return false
    },
    requestStatus () {
      return this.request.status
    },
    showOnAppointments () {
      return this.request.data.payment_appointments_visible
    }
  }
}
</script>



// WEBPACK FOOTER //
// Yoco.vue?47dff5c5